import type { RouteRecordRaw } from 'vue-router';

const getQueryString = (value: unknown) => {
  if (Array.isArray(value)) {
    return value[0] ?? '';
  }

  return typeof value === 'string' ? value : '';
};

// 路由表：禁止任何浏览器副作用 import（无 css / 无进度条 / 无 window 逻辑）。
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('../views/home/index.vue'),
  },

  {
    path: '/profile/:username',
    props: true,
    component: () => import('../views/profile/index.vue'),
  },

  {
    path: '/editor/drafts/:id',
    props: true,
    component: () => import('../views/editor/drafts.vue'),
    meta: {
      ignoreCache: true,
      requiresAuth: true,
    },
  },

  // 导入仓库相关
  {
    path: '/import/callback',
    component: () => import('../views/import/callback.vue'),
    props: route => ({
      code: route.query.code,
      platform: route.query.platform,
      transferRedirect: route.query.transfer_redirect,
      type: route.query.type,
    }),
    meta: {
      ignoreCache: true,
      requiresAuth: true,
    },
  },
  {
    path: '/import/repository',
    component: () => import('../views/import/repository/index.vue'),
    props: route => ({
      platform: route.query.platform,
    }),
    meta: {
      ignoreCache: true,
      requiresAuth: true,
    },
  },
  {
    path: '/import/organization',
    component: () => import('../views/import/organization/index.vue'),
    props: route => ({
      platform: route.query.platform,
    }),
    meta: {
      ignoreCache: true,
      requiresAuth: true,
    },
  },

  {
    path: '/settings',
    component: () => import('../layouts/settings.vue'),
    meta: {
      requiresAuth: true,
    },
    redirect: '/settings/profile',
    children: [
      {
        path: 'article',
        component: () => import('../views/settings/article/index.vue'),
      },
      {
        path: 'favorite',
        component: () => import('../views/settings/favorite/index.vue'),
      },
      {
        path: 'community',
        component: () => import('../views/settings/community/index.vue'),
      },
      {
        path: 'repository',
        component: () => import('../views/settings/platform-resource/repository/index.vue'),
      },
      {
        path: 'organization',
        component: () => import('../views/settings/platform-resource/organization/index.vue'),
      },

      // {
      //   path: 'message',
      //   component: () => import('../views/settings/message/index.vue'),
      // },
      // {
      //   path: 'comment',
      //   component: () => import('../views/settings/comment/index.vue'),
      // },
      {
        path: 'profile',
        component: () => import('../views/settings/profile/index.vue'),
      },
      // {
      //   path: 'notification',
      //   component: () => import('../views/settings/notification/index.vue'),
      // },
    ],
  },

  // 用于模拟第三方登录
  {
    path: '/login/oauth/authorize',
    component: () => import('../views/auth/authorize.vue'),
    props: route => ({
      clientId: getQueryString(route.query.client_id),
      state: getQueryString(route.query.state),
      redirectUri: getQueryString(route.query.redirect_uri),
    }),
  },

  {
    path: '/callback',
    component: () => import('../views/auth/callback.vue'),
    props: route => ({
      code: getQueryString(route.query.code),
      transferRedirect: getQueryString(route.query.transfer_redirect),
      transferType: getQueryString(route.query.transfer_type),
      clientId: getQueryString(route.query.client_id),
      state: getQueryString(route.query.state),
    }),
  },

  {
    path: '/logout',
    component: () => import('../views/auth/logout.vue'),
    props: route => ({
      redirect: getQueryString(route.query.redirect_uri),
    }),
  },

  // 用于兼容老 URL
  {
    path: '/-/profile',
    redirect: '/settings/profile',
  },

  ...(import.meta.env.DEV ? [
    // 测试中心
    {
      path: '/test',
      component: () => import('../layouts/test.vue'),
      children: [
        {
          path: '',
          component: () => import('../views/test/index.vue'),
        },
        {
          path: 'toast',
          component: () => import('../views/test/toast.vue'),
        },
        {
          path: 'dialog',
          component: () => import('../views/test/dialog/index.vue'),
        },
        {
          path: '404-showcase',
          component: () => import('../views/test/404-showcase.vue'),
        },
      ],
    },
  ] : []),

  // 注意：404 路由，业务路由都要放在这前面
  {
    name: 'notFound',
    path: '/404',
    component: () => import('../views/common/404.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/common/404.vue'),
  },
];
